import configService from '../services/config';
import { AppConfig } from '../types/app';

export const isApnDeprecated = (config: AppConfig) => {
  const isHcUATSignIn = configService.isHcUATSignIn();
  return config.enableFullApnDeprecation === 'true' || isHcUATSignIn;
};
